var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8313 4.33734C12.4605 4.33734 0 16.7978 0 32.1687C0 47.5395 12.4605 60 27.8313 60C43.2022 60 55.6626 47.5395 55.6626 32.1687H27.8313V4.33734Z",
    fill: "#4CB36B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1689 0V27.8313H60.0003C60.0003 12.4605 47.5398 0 32.1689 0Z",
    fill: "#4CB36B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPie);
export default __webpack_public_path__ + "static/media/iconPie.ba6d5ba3f5c2d8ee94b0984e917025d4.svg";
export { ForwardRef as ReactComponent };